import { render, staticRenderFns } from "./StaticChart.vue?vue&type=template&id=40ca1f38&scoped=true"
import script from "./StaticChart.vue?vue&type=script&lang=js"
export * from "./StaticChart.vue?vue&type=script&lang=js"
import style0 from "./StaticChart.vue?vue&type=style&index=0&id=40ca1f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ca1f38",
  null
  
)

export default component.exports